import React from 'react';
import { HeaderCellButton } from './HeaderCellButton';

export const NameHeaderCell: React.FunctionComponent = () => {
  return <HeaderCellButton heading="Card" />;
};
